/* Zaroori Jini OMS — Terms of Service. */
import { Section, MarketingShell } from "@/components/marketing/atoms";
import { LegalHero, Legal, H, P, UL } from "@/pages/Privacy";

export default function Terms() {
  return (
    <MarketingShell testid="terms-page">
      <LegalHero eyebrow="Terms" title="Terms of Service" updated="Effective 1 Feb 2026" />
      <Section style={{ background: "#fff" }}>
        <Legal>
          <H>1. Agreement</H>
          <P>
            These Terms govern access to and use of the Zaroori Jini OMS platform (&ldquo;Service&rdquo;)
            operated by Zaroori Retail Pvt. Ltd. (&ldquo;Zaroori&rdquo;, &ldquo;we&rdquo;). By accessing the Service
            you agree to be bound by these Terms.
          </P>

          <H>2. Accounts</H>
          <UL items={[
            "You are responsible for maintaining the confidentiality of your credentials.",
            "You must provide accurate, complete information during onboarding.",
            "You must be 18+ and authorized to bind your organization.",
          ]}/>

          <H>3. Plans & Credits</H>
          <P>
            The Service is offered on a credit-based subscription. 1 credit = 1 order
            processed through the platform. Credits are consumed as orders enter the
            fulfillment pipeline. Plans, prices, and credit pools are described on our
            Pricing page.
          </P>

          <H>4. Acceptable use</H>
          <UL items={[
            "No unlawful, misleading, infringing or fraudulent content.",
            "No reverse engineering, scraping, or bypassing platform limits.",
            "No use that violates marketplace or courier terms of service.",
            "No transmission of malware, phishing content, or spam.",
          ]}/>

          <H>5. Data ownership</H>
          <P>
            You own your operational data. Zaroori is granted a limited license to process
            such data solely to provide the Service. You may export your data at any time
            in structured formats (JSON/CSV).
          </P>

          <H>6. Third-party integrations</H>
          <P>
            Marketplaces, couriers, ERPs and payment providers integrated with the Service
            are governed by their own terms. Zaroori is not liable for outages, policy
            changes, or actions taken by those third parties.
          </P>

          <H>7. Fees, invoicing & taxes</H>
          <UL items={[
            "Fees are quoted in INR and exclude applicable GST.",
            "Invoices are issued monthly or per subscription cycle.",
            "Overdue invoices may attract suspension after a 15-day cure period.",
            "Refunds follow the policy stated on our Pricing page.",
          ]}/>

          <H>8. Confidentiality</H>
          <P>
            Both parties agree to protect confidential information disclosed under this
            agreement and to use it solely for the purpose of performing under these Terms.
          </P>

          <H>9. Warranties & disclaimers</H>
          <P>
            The Service is provided &ldquo;as is&rdquo;. To the maximum extent permitted by law, we
            disclaim all implied warranties. We do not guarantee uninterrupted service or
            that all defects will be corrected.
          </P>

          <H>10. Limitation of liability</H>
          <P>
            To the maximum extent permitted by law, Zaroori&apos;s aggregate liability arising
            out of or relating to these Terms shall not exceed the amounts paid by you to
            Zaroori in the 12 months preceding the claim.
          </P>

          <H>11. Termination</H>
          <P>
            Either party may terminate for material breach uncured for 30 days. Upon
            termination, you will retain access for 30 days to export data. Zaroori may
            suspend the Service immediately for security or legal reasons.
          </P>

          <H>12. Governing law</H>
          <P>
            These Terms are governed by the laws of India. Courts of Gurugram, Haryana
            shall have exclusive jurisdiction. Nothing herein prevents you from seeking
            statutory remedies available in your jurisdiction.
          </P>

          <H>13. Contact</H>
          <P>
            Legal inquiries: <b>legal@zaroorijini.com</b>. Registered office: Zaroori
            Retail Pvt. Ltd., Gurugram, Haryana, India.
          </P>
        </Legal>
      </Section>
    </MarketingShell>
  );
}
